import { Controller, useFormContext } from 'react-hook-form';
import css from './index.module.scss';
import { TextField } from '@components/common';
import { Typography } from '@components/base';
import { getCommaSeperatedCurrencyAmount } from '@helpers/utils';

const DomesticQuotePercentage = (props: any) => {
  const { financeCost, profitMarginExpected, discount, insuranceCost, cmValues, cm2Currency } =
    props;

  const { control } = useFormContext();

  return (
    <>
      <div className={css.rowWrapper}>
        <Controller
          name={financeCost}
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label={
                <span>
                  Finance cost
                  <Typography variant="label"> ( % )</Typography>
                </span>
              }
              placeholder="Enter value in percentage"
              error={fieldState.invalid}
              helperText={
                fieldState.error?.message ??
                (cm2Currency?.label
                  ? getCommaSeperatedCurrencyAmount(cm2Currency?.label, cmValues?.financeCost ?? 0)
                  : undefined)
              }
            />
          )}
        />
        <Controller
          name={profitMarginExpected}
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label={<span>Expected Profit Margin %</span>}
              required
              placeholder="Enter value in percentage"
              error={fieldState.invalid}
              helperText={fieldState.error?.message}
            />
          )}
        />
      </div>
      <div className={css.rowWrapper}>
        <Controller
          name={discount}
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label={
                <span>
                  Discount
                  <Typography variant="label"> ( % )</Typography>
                </span>
              }
              placeholder="Enter value in percentage"
              error={fieldState.invalid}
              helperText={fieldState.error?.message}
            />
          )}
        />
        <Controller
          name={insuranceCost}
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label={
                <span>
                  Insurance Cost
                  <Typography variant="label"> ( % )</Typography>
                </span>
              }
              placeholder="Enter value in percentage"
              error={fieldState.invalid}
              helperText={fieldState.error?.message}
            />
          )}
        />
      </div>
    </>
  );
};

export default DomesticQuotePercentage;
